import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('healthCharts');

    return {
        MOTORS: t('motors'),
        NOZZLES: t('nozzles'),
        PROPS: t('props'),
        PUMPS: t('pumps')
    };
};

export default useTranslation;
